import { Injectable } from '@angular/core';
import { HubspotTokens } from '../models/hubspot-tokens';

@Injectable({
  providedIn: 'root',
})
export class HubspotStorageService {
  private readonly TOKENS_KEY = 'hubspot_tokens';

  setTokens(tokens: HubspotTokens): void {
    localStorage.setItem(this.TOKENS_KEY, JSON.stringify(tokens));
  }

  getTokens() {
    const tokens = localStorage.getItem(this.TOKENS_KEY);
    return tokens ? (JSON.parse(tokens) as HubspotTokens) : null;
  }

  clear(): void {
    localStorage.removeItem(this.TOKENS_KEY);
  }
}
